import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import { computed } from 'vue';
import {
  ISanityDocuments,
  TSanityDocumentPageSchemas,
} from '~/types/sanity-documents';
import { ISanityObjects, SanityObjectSchema } from '~/types/sanity-objects';


export default /*#__PURE__*/_defineComponent({
  __name: 'SanityCta',
  props: {
    urlOrReflink: null,
    ctaStyle: null
  },
  setup(__props: any) {

const props = __props as {
  urlOrReflink: ISanityObjects[SanityObjectSchema.URL_OR_REFLINK];
  ctaStyle: 'primary' | 'secondary';
}



const { $sanityLookup } = useContext();

const getRefLink = (document: ISanityDocuments[TSanityDocumentPageSchemas]) => {
  if (!document?.slug) {
    return;
  }

  const path = $sanityLookup.getPageRoutePath({
    slug: document.slug,
    schema: document._type,
  });

  const suffix =
    props.urlOrReflink.reflinkSuffix &&
    props.urlOrReflink.reflinkSuffix.match(/^#|\?|\//)
      ? props.urlOrReflink.reflinkSuffix
      : '';

  return path + suffix;
};

const isExternalLink = computed(() => {
  if (props.urlOrReflink.linkType === 'docRef') {
    return false;
  }

  if (
    /^https?:\/\//.test(props.urlOrReflink.href ?? '') ||
    /^(tel)|(mailto):/.test(props.urlOrReflink.href ?? '')
  ) {
    return true;
  }

  return false;
});

const target = computed(() => {
  return props.urlOrReflink.blank ? '_blank' : '_top';
});

const classes = computed(() => ({
  'sanity-cta d-inline-flex text-decoration-none align-center justify-center rounded-pill font--button px-4 py-3':
    true,
  'g-background-accent white--text': props.ctaStyle === 'primary',
  'border-white white--text': props.ctaStyle === 'secondary',
}));

return { __sfc: true,props, $sanityLookup, getRefLink, isExternalLink, target, classes }
}

})